module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Veuillez ouvrir une session Sephora',
        termsOfUseLink: 'les conditions d’utilisation et les',
        privacyPolicyLink: 'Politique de confidentialité'
    };

    return resources[label];
};
